module.exports = __webpack_public_path__ + "static/colgadas-010-989a75bdcc54883d8402c0e48cda711e.jpg";